export default __webpack_public_path__ + "static/media/icon3d__team.4ca3b532.png";